import React from "react";
import Chart from "../../Components/chart/Chart";
import { productsData } from "../../datas";
import PublishIcon from "@mui/icons-material/Publish";

import { Link } from "react-router-dom";

import "./Product.css";

function Product() {
  return (
    <div className="product">
      <div className="productTitleContainer">
        <h1 className="productTitle">Product</h1>
        <Link to="/newProduct">
          <button className="productAddButton">Creat</button>
        </Link>
      </div>

      <div className="productTop">
        <div className="productTopRight">
          <Chart title="Sale In Month" data={productsData} datakey="sales" />
        </div>

        <div className="productTopLeft">
          <div className="productInfoTop ">
            <img src="/images/dell.jpg" className="productInfoImg" alt="" />
            <span className="productName">Dell</span>
          </div>

          <div className="productInfoBottom">
            <div className="productInfoKey">ID : </div>
            <div className="productInfoValue">123</div>
          </div>

          <div className="productInfoBottom">
            <div className="productInfoKey">Name : </div>
            <div className="productInfoValue">Dell</div>
          </div>

          <div className="productInfoBottom">
            <div className="productInfoKey">Price</div>
            <div className="productInfoValue">12346</div>
          </div>
        </div>
      </div>

      <div className="productBottom">
        <form className="productForm">
          <div className="productFormLeft">
            <label>Product Name</label>
            <input type="text" placeholder="Dell Laptop" />

            <label>In Stock</label>
            <select id="inStock">
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </select>

            <label>In Active</label>
            <select id="inActive">
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </select>
          </div>

          <div className="productFormRight">
            <div className="productUploder">
              <img
                src="/images/dell.jpg"
                alt="profile"
                className="productUploderImg"
              />
              <label>
                <PublishIcon />
              </label>
              <input type="file" style={{ display: "none" }} />
            </div>
            <button className="productButton">upload (Edit)</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Product;
